
import PropTypes from 'prop-types'
import React from 'react'
import './CollaboratorList.css'

const CollaboratorList = props => (
  <div className='CollaboratorList'>
    {props.children}
  </div>
)

CollaboratorList.propTypes = {
  children: PropTypes.array.isRequired
}

CollaboratorList.displayName = 'CollaboratorList'

export default CollaboratorList



// WEBPACK FOOTER //
// ./ui/CollaboratorList.js